import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Trophy, Medal, Award } from "lucide-react";
import ReferralBadge from "@/components/ReferralBadge";

const RANK_ICON = { 1: Trophy, 2: Medal, 3: Award };
const RANK_COLOR = { 1: "text-yellow-500 bg-yellow-50 border-yellow-200", 2: "text-slate-500 bg-slate-50 border-slate-200", 3: "text-amber-600 bg-amber-50 border-amber-200" };

export default function ReferralLeaderboard() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/referrals/leaderboard").then((r) => setRows(r.data.leaderboard || [])).catch(()=>{}); }, []);

  if (!rows.length) return null;

  return (
    <Card className="trust-card" data-testid="referral-leaderboard-card">
      <CardContent className="p-6 sm:p-8">
        <div className="flex items-center gap-2 mb-4">
          <Trophy className="w-5 h-5 text-yellow-500" />
          <h2 className="text-xl font-semibold text-slate-900">Referral leaderboard</h2>
        </div>
        <p className="text-sm text-slate-500 mb-6">Top referrers earning credit for helping people find us.</p>
        <div className="space-y-2" data-testid="leaderboard-rows">
          {rows.map((r) => {
            const Icon = RANK_ICON[r.rank];
            return (
              <div key={r.rank} className="flex items-center gap-4 p-3 rounded-xl border border-slate-200 hover:bg-slate-50" data-testid={`leaderboard-row-${r.rank}`}>
                <div className={`w-9 h-9 rounded-full grid place-items-center border ${RANK_COLOR[r.rank] || "text-slate-400 bg-slate-50 border-slate-200"}`}>
                  {Icon ? <Icon className="w-4 h-4" /> : <span className="text-sm font-bold">{r.rank}</span>}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <p className="font-semibold text-slate-900 truncate">{r.display_name}</p>
                    <ReferralBadge count={r.referrals} />
                  </div>
                  <p className="text-xs text-slate-500">{r.referrals} paid referral{r.referrals === 1 ? "" : "s"}</p>
                </div>
                <div className="text-right">
                  <p className="text-sm font-bold text-emerald-700">${r.total_credit.toFixed(0)}</p>
                  <p className="text-[10px] text-slate-400 uppercase tracking-widest">earned</p>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
